var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.maintenanceInfo)?_c('v-alert',{staticClass:"mt-8",attrs:{"dense":"","colored-border":"","text":"","border":"left","elevation":"2","id":"maintenance_info","type":"warning"}},[_vm._v(" "+_vm._s(_vm.maintenanceInfo)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }